import React, { useRef, useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { Navigation, Autoplay, Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';

// Import language context
import { useLanguage } from '../../contexts/LanguageContext';

const slides = [
  process.env.PUBLIC_URL + '/assets/img/slider/HeroSlider/Slider-1.jpg',
  process.env.PUBLIC_URL + '/assets/img/slider/HeroSlider/Slider-2.jpg',
  process.env.PUBLIC_URL + '/assets/img/slider/HeroSlider/Slider-3.png',
  process.env.PUBLIC_URL + '/assets/img/slider/HeroSlider/Slider-4.png',
];

const HeroSlider = ({
  T11 = "Beyond Sorting ",
  T12 = "Delivering Material Intelligence",
}) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  // Translation
  const { currentLanguage, translateContent } = useLanguage();
  const [translations, setTranslations] = useState({ T11, T12 });

  useEffect(() => {
    const translateAll = async () => {
      const originalTexts = { T11, T12 };
      const newTranslations = {};

      const results = await Promise.all(
        ['T11', 'T12'].map(async (key) => {
          const translated = await translateContent(originalTexts[key]);
          return { key, translated };
        })
      );

      results.forEach(({ key, translated }) => {
        newTranslations[key] = translated;
      });

      setTranslations(newTranslations);
    };

    translateAll();
  }, [currentLanguage, T11, T12, translateContent]);

  const navBtnStyle = {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 10,
    width: 48,
    height: 48,
    borderRadius: '50%',
    border: 'none',
    background: 'rgba(0,0,0,0.55)',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  };

  return (
    <section className="slider-area fix" style={{ position: 'relative' }}>
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        autoplay={{ delay: 5000
          , disableOnInteraction: false }}
        loop
        effect="fade"
        speed={900}
        pagination={{ clickable: true }}
        navigation={{ prevEl: prevRef.current, nextEl: nextRef.current }}
        onBeforeInit={(swiper) => {
          swiper.params.navigation.prevEl = prevRef.current;
          swiper.params.navigation.nextEl = nextRef.current;
        }}
        keyboard={{ enabled: true }}
        allowTouchMove
        fadeEffect={{ crossFade: true }}
      >
        {slides.map((src, idx) => (
          <SwiperSlide key={idx}>
            <div className="item-slider sliderm-height p-relative">
              <img
                src={src}
                alt={`Hero slide ${idx + 1}`}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  objectPosition: idx === 1 ? 'center 35%' : 'center',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  zIndex: -1,
                }}
              />
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="slider-contant mt-25">
                      <span style={{ fontSize: 'clamp(22px, 5vw, 50px)' }}>{translations.T11}</span>
                      <h2 className="slider-title" style={{ fontSize: 'clamp(28px, 6vw, 70px)' }}>{translations.T12}</h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <button
        ref={prevRef}
        type="button"
        aria-label="Previous slide"
        className="hero-nav-btn prev"
        style={{ ...navBtnStyle, left: 14 }}
      >
        <FiChevronLeft size={28} />
      </button>
      <button
        ref={nextRef}
        type="button"
        aria-label="Next slide"
        className="hero-nav-btn next"
        style={{ ...navBtnStyle, right: 14 }}
      >
        <FiChevronRight size={28} />
      </button>
    </section>
  );
};

export default HeroSlider;